var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFull1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 60 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6 44.12a1.6 1.6 0 0 1 2.26.03 9.5 9.5 0 0 0 9.48 2.55 9.6 9.6 0 0 0 6.72-7.21 1.6 1.6 0 1 1 3.13.7 12.83 12.83 0 0 1-8.97 9.63 12.69 12.69 0 0 1-12.66-3.41c-.62-.64-.6-1.67.03-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m48.95 2.57-9.6 7.04L25.79 0 15.9 13.54 4.71 9.94l6.34 19.48v.55A6.87 6.87 0 0 0 4.5 36.8a6.82 6.82 0 0 0 6.78 6.85h.5C14.03 51.31 21.34 56.9 30 56.9c8.65 0 15.96-5.58 18.23-13.23h.71a6.82 6.82 0 0 0 6.56-6.85v-.23a6.82 6.82 0 0 0-6.55-6.62V2.57Zm-34.6 27.15-.03 8.92c0 8.14 6.84 14.78 15.37 14.94H30c8.57 0 15.51-6.55 15.67-14.65v-14.5l-31.32 5.29Zm37.88 7.1a3.53 3.53 0 0 1-3.28 3.53v-7.07l.36.04a3.53 3.53 0 0 1 2.92 3.5Zm-41.36-3.53.18-.01v7.07a3.53 3.53 0 0 1-3.28-3.54 3.53 3.53 0 0 1 3.1-3.52ZM5.83 74.28v-8.4H.67v8.4a9.34 9.34 0 0 0 9.29 9.39c5.13 0 9.28-4.2 9.28-9.39v-8.4h-5.16v8.4c0 2.3-1.43 4.45-4.12 4.45-2.7 0-4.13-2.14-4.13-4.45Zm20.04 0v-8.4h-5.16v8.4A9.34 9.34 0 0 0 30 83.67c5.13 0 9.29-4.2 9.29-9.39v-8.4h-5.16v8.4c0 2.3-1.54 4.45-4.13 4.45-2.6 0-4.13-2.14-4.13-4.45Zm24.17-8.4c5.13 0 9.3 3.99 9.3 8.9 0 4.9-4.17 8.89-9.3 8.89h-9.28V65.89h9.28Zm.25 4.45h-4.37v8.9h4.37c2.03 0 3.88-2 3.88-4.45 0-2.46-1.85-4.45-3.88-4.45Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull1);
export default __webpack_public_path__ + "static/media/logo_full1.4b9a21be0d2bcd5cd241dbebbda5cf10.svg";
export { ForwardRef as ReactComponent };